/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iade_Iptal_S3_HeadingInputs */

const tr_iade_iptal_s3_heading = /** @type {(inputs: Iade_Iptal_S3_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3. Abone'nin İptal ve Fesih Hakkı (6502 Madde 52, Abonelik Sözleşmeleri Yönetmeliği Madde 22)`)
};

const en_iade_iptal_s3_heading = /** @type {(inputs: Iade_Iptal_S3_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3. The Subscriber's Right of Cancellation and Termination (6502 Madde 52, Abonelik Sözleşmeleri Yönetmeliği Madde 22)`)
};

const de_iade_iptal_s3_heading = /** @type {(inputs: Iade_Iptal_S3_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3. Kündigungs- und Beendigungsrecht des Abonnenten (6502 Madde 52, Abonelik Sözleşmeleri Yönetmeliği Madde 22)`)
};

const ru_iade_iptal_s3_heading = /** @type {(inputs: Iade_Iptal_S3_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3. Право Абонента на отмену и расторжение (6502 Madde 52, Abonelik Sözleşmeleri Yönetmeliği Madde 22)`)
};

/**
* | output |
* | --- |
* | "3. The Subscriber's Right of Cancellation and Termination (6502 Madde 52, Abonelik Sözleşmeleri Yönetmeliği Madde 22)" |
*
* @param {Iade_Iptal_S3_HeadingInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const iade_iptal_s3_heading = /** @type {((inputs?: Iade_Iptal_S3_HeadingInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iade_Iptal_S3_HeadingInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_iade_iptal_s3_heading(inputs)
	if (locale === "de") return de_iade_iptal_s3_heading(inputs)
	if (locale === "ru") return ru_iade_iptal_s3_heading(inputs)
	return tr_iade_iptal_s3_heading(inputs)
});